import { render, staticRenderFns } from "./MachinesComments.vue?vue&type=template&id=1153e046&"
import script from "./MachinesComments.vue?vue&type=script&lang=js&"
export * from "./MachinesComments.vue?vue&type=script&lang=js&"
import style0 from "./MachinesComments.vue?vue&type=style&index=0&id=1153e046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports